<template>
  <div
    class="user-icon"
    style="margin-left: 0.25em; margin-right: 0.25em"
  >
    <span
      v-show="isAdmin()"
      v-tooltip="{ content: 'Administrator' }"
      data-testid="user-admin-icon"
      class="user-admin-icon"
      v-html="adminIcon"
    >
    </span>
    <span
      v-show="isGroupAdmin()"
      v-tooltip="{ content: 'Group Administrator' }"
      data-testid="user-group-admin-icon"
      class="user-admin-icon"
      v-html="groupAdminIcon"
    >
    </span>
  </div>
</template>

<script>
import feather from 'feather-icons'

export default {
  name: 'UserIcon',
  props: ['roles'],
  data() {
    return {
      adminIcon: feather.icons.shield.toSvg({width: '1em', height: '1em'}),
      groupAdminIcon: feather.icons.users.toSvg({width: '1em', height: '1em'}),
    }
  },
  methods: {
    isAdmin() {
      if (this.roles) {
        return this.roles[0].name === 'administrator'
      }
    },
    isGroupAdmin() {
      if (this.roles) {
        return this.roles[0].name === 'groupAdmin'
      }
    },
  },
}
</script>
